/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatedInternationalAddress,
  formatMobile,
  formatName,
  formatNumber,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import {
  API,
  cddCustomerTypeOptions,
  cddOptions,
  customerType,
  entityType,
  get,
  riskProfile,
} from "../../config";
import { Button } from "../../components/ui/button";
import ContactSummary from "../Reports/Statements/ContactSummary";
import { useOrganization } from "../../lib/context/OrganisationContext";

const ContactDetailsPopup = ({
  org,
  contactId,
  // toggleShowModal,
  showView,
  setShowView,
  trustId,
  contact,
}) => {
  const [contactDetail, setContactDetail] = useState(null);
  const [contactLoading, setContactLoading] = useState(true);
  const [showStatement, setShowStatement] = useState(null);
  const { organizationData } = useOrganization();

  const normalizeVerificationData = (data = {}, verificationType = {}) => {
    if (!verificationType?.fields) return data;

    const dateKeys = verificationType.fields
      .filter((f) => f.inputType === "date")
      .map((f) => f.key);

    const normalizedData = { ...data };

    dateKeys.forEach((key) => {
      if (normalizedData[key]) {
        // eslint-disable-next-line no-self-assign
        normalizedData[key] = normalizedData[key];
      }
    });
    return normalizedData;
  };

  const toggleStatement = () => {
    setShowStatement(!showStatement);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(`${API.CONTACT_DETAILS}/` + contactId);

        data?.data?.kyc &&
          data?.data?.kyc?.verifications?.length > 0 &&
          data?.data?.kyc?.verifications?.map((item) => {
            const normalizedData = normalizeVerificationData(
              item.data,
              item.verification_document_type,
            );
            item.date_verified = item.date_verified ? item.date_verified : null;
            item.verified_by = item?.verified_by ? item?.verified_by : "";
            item.type = item?.verification_document_type_id
              ? item?.verification_document_type_id
              : "";
            item.fields = item.verification_document_type.fields?.map(
              (field) => ({
                key: field.key,
                label: field.label,
                value: normalizedData?.[field.key] ?? null,
                inputType: field.inputType || "text",
              }),
            );
            return item;
          });
        setContactDetail(data.data);
        setContactLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [contactId, setContactDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      )} Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      <>
        {contactLoading ? (
          <Spin full expand={true} />
        ) : (
          <div className="md:p-0 p-4">
            <div className="modal-content">
              <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                Personal Details{" "}
                {!org && (
                  <div>
                    <Button
                      className="p-2 h-6 mb-1.5"
                      onClick={() => {
                        toggleStatement();
                      }}
                    >
                      View Statement
                    </Button>
                  </div>
                )}
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                {org && (
                  <p>
                    <strong>Trust:</strong>{" "}
                    {contactDetail?.trust
                      ? formatSubcontractorName(contactDetail?.trust)
                      : "AML-CTF"}
                  </p>
                )}
                <p>
                  <strong>First Name:</strong>{" "}
                  {contactDetail?.first_name ? contactDetail?.first_name : "-"}
                </p>
                <p>
                  <strong>Last Name:</strong> {contactDetail?.last_name}
                </p>
                <p>
                  <strong>Email Address:</strong> {contactDetail?.email}
                </p>
                <p>
                  <strong>Phone Number:</strong>{" "}
                  {contactDetail?.phone
                    ? formatPhone(contactDetail?.phone)
                    : ""}
                </p>
                <p>
                  <strong>Mobile Number:</strong>{" "}
                  {contactDetail?.mobile
                    ? formatMobile(contactDetail?.mobile)
                    : "-"}
                </p>
                <p>
                  <strong>Business Name:</strong>{" "}
                  {contactDetail?.business_name
                    ? contactDetail?.business_name
                    : "-"}
                </p>

                <p>
                  <strong>ABN:</strong>{" "}
                  {contactDetail?.abn ? formatABN(contactDetail?.abn) : "-"}
                </p>
                <p>
                  <strong>Code:</strong>{" "}
                  {contactDetail?.code ? contactDetail?.code : "-"}
                </p>
                <p>
                  <strong>Date of Birth:</strong>{" "}
                  {contactDetail?.dob ? contactDetail?.dob : "-"}
                </p>
                <p>
                  <strong>Licence Number:</strong>{" "}
                  {contactDetail?.license_number
                    ? contactDetail?.license_number
                    : "-"}
                </p>
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Address:</strong>{" "}
                  {contactDetail?.international_address
                    ? formatedInternationalAddress(
                        contactDetail?.full_address,
                        contactDetail?.country?.name,
                      )
                    : formatedAddress(
                        contactDetail?.street,
                        contactDetail?.suburb?.name,
                        contactDetail?.state?.name,
                        contactDetail?.postal_code,
                      )}
                </p>
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                  {contactDetail?.shipping_international_address
                    ? formatedInternationalAddress(
                        contactDetail?.shipping_full_address,
                        contactDetail?.shipping_country?.name,
                      )
                    : formatedAddress(
                        contactDetail?.shipping_street,
                        contactDetail?.shipping_suburb?.name,
                        contactDetail?.shipping_state?.name,
                        contactDetail?.shipping_postal_code,
                      )}
                </p>
                <p>
                  <strong>Client Type:</strong>{" "}
                  {contactDetail?.type
                    ? customerType?.find(
                        (item) => item.value == contactDetail?.code,
                      )?.label
                    : "-"}
                </p>
                {contactDetail?.type == "2" && (
                  <p>
                    <strong>Entity Type:</strong>{" "}
                    {contactDetail?.type
                      ? entityType?.find(
                          (item) => item.value == contactDetail?.code,
                        )?.label
                      : "-"}
                  </p>
                )}
              </div>
            </div>
            {contactDetail?.account_name && (
              <div className="modal-content mt-4">
                <CardTitle className="text-md mb-2">
                  Bank Account Details
                </CardTitle>
                <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                  <p>
                    <strong>Bank Name:</strong>{" "}
                    {contactDetail?.bank
                      ? contactDetail?.bank?.abbreviation +
                        "-" +
                        contactDetail?.bank?.name
                      : "-"}
                  </p>
                  <p>
                    <strong>Bank Account Name:</strong>{" "}
                    {contactDetail?.account_name
                      ? contactDetail?.account_name
                      : "-"}
                  </p>
                  <p>
                    <strong>BSB:</strong>{" "}
                    {contactDetail?.bsb
                      ? formatBSBNumber(contactDetail?.bsb)
                      : "-"}
                  </p>
                  <p>
                    <strong>Account Number:</strong>{" "}
                    {contactDetail?.account_number
                      ? formatAccountNumber(contactDetail?.account_number)
                      : "-"}
                  </p>
                  <p>
                    <strong>Opening Balance:</strong>{" "}
                    {contactDetail?.opening_balance
                      ? "$" +
                        formatNumber(Number(contactDetail?.opening_balance))
                      : "$0.00"}
                  </p>
                </div>
              </div>
            )}

            {contactDetail?.is_kyc && (
              <div className="modal-content mt-4">
                <CardTitle className="text-md mb-2">
                  Proof of ID for Vendor Verification (KYC)
                </CardTitle>
                <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                  <p>
                    <strong>CDD Customer Type:</strong>{" "}
                    {contactDetail?.kyc?.cdd_customer_type
                      ? cddCustomerTypeOptions?.find(
                          (item) =>
                            item.value ===
                            contactDetail?.kyc?.cdd_customer_type,
                        )?.label
                      : "-"}
                  </p>

                  <p>
                    <strong>CDD:</strong>{" "}
                    {contactDetail?.kyc?.cdd
                      ? cddOptions?.find(
                          (item) => item.value === contactDetail?.kyc?.cdd,
                        )?.label
                      : "-"}
                  </p>
                  <p>
                    <strong>Risk Profile:</strong>{" "}
                    {contactDetail?.kyc?.risk
                      ? riskProfile?.find(
                          (item) => item.value === contactDetail?.kyc?.risk,
                        )?.label
                      : "-"}
                  </p>

                  {contactDetail?.is_kyc &&
                    contactDetail?.kyc?.risk_profile_changes
                      ?.compliance_manager_id && (
                      <>
                        <p>
                          <strong>Escalated To:</strong>{" "}
                          {contactDetail?.kyc?.risk_profile_changes
                            ?.compliance_manager_name
                            ? contactDetail?.kyc?.risk_profile_changes
                                ?.compliance_manager_name
                            : "-"}
                        </p>

                        <p>
                          <strong>Reason:</strong>{" "}
                          {contactDetail?.kyc?.risk_profile_changes?.reason
                            ? contactDetail?.kyc?.risk_profile_changes?.reason
                            : "-"}
                        </p>
                      </>
                    )}
                </div>
                {contactDetail?.kyc?.verifications?.map(
                  (verifyItem, verifyIndex) => (
                    <>
                      {verifyIndex !== 0 && <hr className="my-2" />}
                      <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                        <p>
                          <strong>Verification Method:</strong>{" "}
                          {verifyItem?.method_title
                            ? verifyItem?.method_title
                            : "-"}
                        </p>
                        <p>
                          <strong>Document Id:</strong>{" "}
                          {verifyItem?.verification_document_type?.label
                            ? verifyItem?.verification_document_type?.label
                            : "-"}
                        </p>
                        {verifyItem?.method === 1 && (
                          <p>
                            <strong>Document Number:</strong>{" "}
                            {verifyItem?.document_number
                              ? verifyItem?.document_number
                              : "-"}
                          </p>
                        )}

                        {verifyItem?.method === 3 && (
                          <>
                            {verifyItem?.fields?.length > 0 &&
                              verifyItem?.fields?.map((field) => (
                                <p key={field.key}>
                                  <strong>{field.label}:</strong> {field.value}
                                </p>
                              ))}
                          </>
                        )}
                        <p>
                          <strong>Verification Date:</strong>{" "}
                          {verifyItem?.date_verified
                            ? verifyItem?.date_verified
                            : "-"}
                        </p>
                        <p>
                          <strong>Verified By:</strong>{" "}
                          {verifyItem?.verified_by
                            ? formatName(
                                verifyItem?.verified_by?.first_name,
                                verifyItem?.verified_by?.last_name,
                              )
                            : "-"}
                        </p>
                      </div>
                    </>
                  ),
                )}
              </div>
            )}

            {contactDetail?.is_kyc &&
              contactDetail?.beneficiaries?.length > 0 && (
                <div className="modal-content">
                  <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                    Beneficiaries
                  </CardTitle>
                  {contactDetail?.beneficiaries?.map((bItem, bIndex) => (
                    <>
                      {bIndex !== 0 && <hr className="my-2" />}
                      <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                        <p>
                          <strong>Name:</strong>{" "}
                          {bItem?.name ? bItem?.name : "-"}
                        </p>
                        <p>
                          <strong>Percentage:</strong>{" "}
                          {bItem?.percentage ? `${bItem?.percentage}%` : "-"}
                        </p>
                      </div>
                    </>
                  ))}
                </div>
              )}

            {contactDetail?.joint_accounts?.length > 0 && (
              <div className="modal-content">
                <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                  Joint Account
                </CardTitle>
                {contactDetail?.joint_accounts?.map((jointItem, jointIndex) => (
                  <>
                    {jointIndex !== 0 && <hr className="my-2" />}
                    <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                      <p>
                        <strong>First Name:</strong>{" "}
                        {jointItem?.first_name ? jointItem?.first_name : "-"}
                      </p>
                      <p>
                        <strong>Last Name:</strong>{" "}
                        {jointItem?.last_name ? jointItem?.last_name : "-"}
                      </p>
                      <p>
                        <strong>Date of Birth:</strong>{" "}
                        {jointItem?.dob ? jointItem?.dob : "-"}
                      </p>
                      <p className="flex gap-1">
                        <strong className="whitespace-nowrap">Address:</strong>{" "}
                        {jointItem?.international_address
                          ? formatedInternationalAddress(
                              jointItem?.full_address,
                              jointItem?.country?.name,
                            )
                          : formatedAddress(
                              jointItem?.street,
                              jointItem?.suburb?.name,
                              jointItem?.state?.name,
                              jointItem?.postal_code,
                            )}
                      </p>

                      <p>
                        <strong>Bank Name:</strong>{" "}
                        {jointItem?.bank
                          ? jointItem?.bank?.abbreviation +
                            "-" +
                            jointItem?.bank?.name
                          : "-"}
                      </p>
                      <p>
                        <strong>Bank Account Name:</strong>{" "}
                        {jointItem?.account_name
                          ? jointItem?.account_name
                          : "-"}
                      </p>
                      <p>
                        <strong>BSB:</strong>{" "}
                        {jointItem?.bsb ? formatBSBNumber(jointItem?.bsb) : "-"}
                      </p>
                      <p>
                        <strong>Account Number:</strong>{" "}
                        {jointItem?.account_number
                          ? formatAccountNumber(jointItem?.account_number)
                          : "-"}
                      </p>
                    </div>
                  </>
                ))}
              </div>
            )}
          </div>
        )}
        <ResponsiveDrawerForm
          description={""}
          title={`${getModuleNamingBySlug(
            organizationData?.organizationData,
            "contacts",
            "Customer",
          )} Statment`}
          handleOpen={() => {}}
          handleClose={() => {}}
          className={"md:w-[90vw]"}
          open={showStatement}
          buttonClassName={""}
          setOpen={setShowStatement}
          read={true}
          popupType={"reports"}
        >
          <ContactSummary id={contactId} trustId={trustId} contact={contact} />
        </ResponsiveDrawerForm>
      </>
    </ResponsiveDrawerForm>
  );
};

export default ContactDetailsPopup;
